module.exports = __webpack_public_path__ + "img/7_159.71db5e1a.png";